import { HTMLAttributes } from 'react';

import { QuoteIcon } from '@radix-ui/react-icons';
import { useEditorState, type Editor } from '@tiptap/react';

import { Toggle } from '../../../primitives/toggle';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../primitives/tooltip';

interface ToggleQuoteProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
  editor: Editor;
}

export function ToggleQuote({ className, editor }: ToggleQuoteProps) {
  const { isBlockquote } = useEditorState({
    editor,
    selector: ({ editor }: { editor: Editor }) => ({
      isBlockquote: editor.isActive('blockquote'),
    }),
  });

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div>
          <Toggle
            aria-label="Agregar cita"
            className={className}
            disabled={!editor.isEditable}
            pressed={isBlockquote}
            size="icon"
            variant="ghost"
            onPressedChange={() => editor.chain().focus().toggleBlockquote().run()}
          >
            <QuoteIcon className="size-4" />
          </Toggle>
        </div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="flex flex-col">
          Cita <span className="text-accent">⌘⇧B</span>
        </p>
      </TooltipContent>
    </Tooltip>
  );
}
